import { FloatingDock } from "../components/FloatingDock";
import TextGenerator from "../components/TextGenerator";
import { motion } from "framer-motion";
import {
	IconHome,
	IconDeviceLaptop,
	IconMessage,
	IconCode,
	IconBrandLinkedin,
	IconBrandInstagram,
} from "@tabler/icons-react";
import { WorldMap } from "../components/WorldMap";
import { Card, CardType, Carousel } from "../components/AppleCarousel";
import QuestionForm from "../components/QuestionForm";
import { Toaster } from "../components/Toaster";
import { analytics } from "../firebase";
import { logEvent } from "firebase/analytics";

type Props = {};

const products: CardType[] = [
	{
		category: "SaaS",
		title: "TestMate",
		src: require("../assets/testmate.jpeg"),
		link: "http://test-mate-softwarify.vercel.app",
		content: {
			text: "Meet Google Play's 12-tester requirement instantly with our pre-verified tester accounts - launch your app faster without the hassle.",
			url: "http://test-mate-softwarify.vercel.app",
		},
	},
	{
		category: "Mobile App",
		title: "Grammify - Grammar Fixer",
		src: require("../assets/grammify.jpeg"),
		link: "https://apps.apple.com/tr/app/grammify-grammar-fix/id6739960623",
		content: {
			text: "Grammify is a mobile application powered by artificial intelligence, designed for quick and practical use as a grammar correction assistant. Whether you want to check if a sentence is correctly written in the language you're learning or translate a sentence from your native language into the target language with perfect grammar, Grammify has you covered",
			url: "https://apps.apple.com/tr/app/grammify-grammar-fix/id6739960623",
		},
	},
	{
		category: "Mobile App",
		title: "Plant Indetification 6 Diagnoser - Verdant",
		src: require("../assets/florai.png"),
		link: "https://apps.apple.com/tr/app/florai-plant-id-care/id6504121337",
		content: {
			text: "Unlock the wonders of nature with FlorAl, your all-in-one app for discovering, identifying, and caring for plants, flowers, mushrooms, and trees. Whether you're a plant parent, a curious explorer, or a gardening enthusiast, FlorAl makes plant identification and care simple, accurate, and fun.",
			url: "https://apps.apple.com/tr/app/florai-plant-id-care/id6504121337",
		},
	},
	{
		category: "Mobile App",
		title: "NotEt",
		src: require("../assets/notet.jpeg"),
		link: "https://apps.apple.com/tr/app/notet/id1569848177",
		content: {
			text: "NotEt allows you to take notes and add a reminder to these notes at the date and time you want, and then you will be reminded of the relevant note via notification. If you wish, you can sign up with your email and name and surname from the profile screen so that we can support us and improve the application further.",
			url: "https://apps.apple.com/tr/app/notet/id1569848177",
		},
	},

	// {
	// 	category: "Product",
	// 	title: "Maps for your iPhone 15 Pro Max.",
	// 	src: "https://images.unsplash.com/photo-1599202860130-f600f4948364?q=80&w=2515&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
	// 	content: <DummyContent />,
	// },
	// {
	// 	category: "iOS",
	// 	title: "Photography just got better.",
	// 	src: "https://images.unsplash.com/photo-1602081957921-9137a5d6eaee?q=80&w=2793&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
	// 	content: <DummyContent />,
	// },
	// {
	// 	category: "Hiring",
	// 	title: "Hiring for a Staff Software Engineer",
	// 	src: "https://images.unsplash.com/photo-1511984804822-e16ba72f5848?q=80&w=2048&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
	// 	content: <DummyContent />,
	// },
];
const services: CardType[] = [
	{
		category: "UI/UX",
		title: "Business analysis and UI/UX design to cover up every point",
		src: "https://images.unsplash.com/photo-1680016661694-1cd3faf31c3a?q=80&w=3474&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
		link: "https://www.linkedin.com/company/softwarify/",
	},
	{
		category: "Development",
		title: "Tailored software development (mobile or web) services to satisfy your unique needs",
		src: "https://images.unsplash.com/photo-1599202860130-f600f4948364?q=80&w=2515&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
		link: "https://www.linkedin.com/company/softwarify/",
	},
	{
		category: "Hiring",
		title: "IT Recruitment & Developer Outsourcing",
		src: "https://images.unsplash.com/photo-1511984804822-e16ba72f5848?q=80&w=2048&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
		link: "https://www.linkedin.com/company/softwarify/",
	},
];
const HomePage = (props: Props) => {
	var deviceId = localStorage.getItem("sftdvcid");

	const _products = products.map((prod, index) => <Card key={prod.src} card={prod} index={index} />);
	const _services = services.map((card, index) => <Card key={card.src} card={card} index={index} />);
	const scrollToElement = (id: string) => {
		const element = document.getElementById(id); // Find the element by its ID
		if (element) {
			element.scrollIntoView({ behavior: "smooth", block: "start" });
		}
	};
	return (
		<div className='flex relative overflow-y-scroll overflow-x-hidden gap-y-10 flex-col no-scrollbar items-center justify-center bg-gradient-to-br from-slate-800 via-slate-950 to-slate-800'>
			<Toaster />
			<motion.section
				id='home'
				className='w-screen lg:h-screen py-5 space-y-10 overflow-hidden'
				initial={{
					opacity: 0,
					x: -50,
				}}
				whileInView={{
					opacity: 1,
					x: 0,
					transition: {
						duration: 0.5,
						ease: "easeInOut",
					},
				}}
				onViewportEnter={() => {
					logEvent(analytics, "section_visited", { deviceId, section: "home" });
					document.title = "Welcome to Softwarify | Premium Software Solutions & Services";
				}}>
				<TextGenerator
					words='Softwarify, builds unique products with a sophisticated approach, globally.'
					className='mt-10'
				/>
				<div className='lg:w-10/12 w-11/12 mx-auto text-center'>
					<WorldMap
						dots={[
							{
								start: {
									lat: 28.015137,
									lng: 29.99953,
								}, // istanbul
								end: {
									lat: 53.0522,
									lng: -129.2437,
								}, // Los Angeles
							},
							{
								start: {
									lat: 53.0522,
									lng: -129.2437,
								},
								end: { lat: 48.0, lng: -63.0 }, // new york
							},
							{
								start: { lat: 48.0, lng: -63.0 },
								end: { lat: 53.520008, lng: 14.404954 }, // berlin
							},
							{
								start: { lat: 53.520008, lng: 14.404954 }, // berlin
								end: { lat: 51.5074, lng: -3.1278 }, // London
							},
							{
								start: { lat: 51.5074, lng: -3.1278 }, // London
								end: { lat: 60.3676, lng: 9.9041 }, // amsterdam
							},
							{
								start: { lat: 60.3676, lng: 9.9041 }, // amsterdam
								end: { lat: 69.3327, lng: 18.0656 }, // stockholm
							},
							{
								start: { lat: 69.3327, lng: 18.0656 }, // stockholm
								end: {
									lat: 28.015137,
									lng: 29.99953,
								}, // istanbul
							},
						]}
					/>
				</div>
			</motion.section>
			<motion.section
				id='products'
				className='w-screen lg:h-screen py-20 space-y-10 overflow-hidden'
				initial={{
					opacity: 0,
					x: -50,
				}}
				whileInView={{
					opacity: 1,
					x: 0,
					transition: {
						duration: 0.5,
						ease: "easeInOut",
					},
				}}
				onViewportEnter={() => {
					logEvent(analytics, "section_visited", {
						deviceId,
						section: "products",
					});
					document.title = "Products of Softwarify | Premium Software Solutions & Services";
				}}>
				<h1 className='max-w-7xl pl-4 text-2xl md:text-5xl font-bold text-neutral-800 dark:text-neutral-200 font-sans text-center lg:text-start mx-auto'>
					Products
				</h1>
				<Carousel items={_products} />
			</motion.section>
			<motion.section
				onViewportEnter={() => {
					logEvent(analytics, "section_visited", {
						deviceId,
						section: "services",
					});
					document.title = "Services of Softwarify | Premium Software Solutions & Services";
				}}
				id='services'
				className='w-screen lg:h-screen py-20 space-y-10 overflow-hidden'
				initial={{
					opacity: 0,
					x: -50,
				}}
				whileInView={{
					opacity: 1,
					x: 0,
					transition: {
						duration: 0.5,
						ease: "easeInOut",
					},
				}}>
				<h1 className='max-w-7xl pl-4 text-2xl md:text-5xl font-bold text-neutral-800 dark:text-neutral-200 font-sans text-center lg:text-start mx-auto'>
					Services
				</h1>
				<Carousel items={_services} />
			</motion.section>
			<motion.section
				onViewportEnter={() => {
					logEvent(analytics, "section_visited", {
						deviceId,
						section: "aboutus",
					});
					document.title = "About Softwarify | Premium Software Solutions & Services";
				}}
				className='w-screen lg:h-screen py-20 space-y-10 overflow-hidden'
				id='aboutus'
				initial={{
					opacity: 0,
					x: -50,
				}}
				whileInView={{
					opacity: 1,
					x: 0,
					transition: {
						duration: 0.5,
						ease: "easeInOut",
					},
				}}>
				<h1 className='max-w-7xl pl-4 text-2xl md:text-5xl font-bold text-neutral-800 dark:text-neutral-200 font-sans text-center lg:text-start mx-auto'>
					About Us
				</h1>
				<p className='text-center text-lg w-10/12 lg:w-1/2 mx-auto'>
					<b>Softwarify</b>, founded by{" "}
					<a href='http://linkedin.com/in/sefailyasoz/' target='_blank' className='underline' rel='noreferrer'>
						Sefa İlyas Öz
					</a>{" "}
					in 2023.
					<br />
					<span>
						Our founder started as a freelance software engineer but eventually decided to establish a company to offer
						more professional services to clients worldwide
					</span>
					<br />
					<br />
					<span>
						Now as <b>Softwarify</b>, we provide premium software services to companies by developing tailored software
						solutions. To achieve this, we ensure we fully understand our customers' needs and provide feedback at every
						step of the process.
					</span>
					<br />
					<br />
					<span>Also we build our own products like mobile apps and software as a service products.</span>
					<br />
					<br />
					<span>
						We specialized in web and mobile app development and our sector range is quite wide. From Warehouse
						Management System (WMS) to Content Management System (CMS), Health Safety and Environment (HSE) to Customer
						Relationship Management (CRM), E-Commerce to SaaS Apps, you name it we can build it.
					</span>
					<br />
					<br />
					<span>
						<span className='underline cursor-pointer' onClick={() => scrollToElement("contact")}>
							Contact us
						</span>{" "}
						now and take the first step toward premium software services.
					</span>
				</p>
			</motion.section>
			<motion.section
				onViewportEnter={() => {
					logEvent(analytics, "section_visited", {
						deviceId,
						section: "contact",
					});

					document.title = "Contact with Softwarify | Premium Software Solutions & Services";
				}}
				initial={{
					opacity: 0,
					x: -50,
				}}
				whileInView={{
					opacity: 1,
					x: 0,
					transition: {
						duration: 0.5,
						delay: 0.2,
						ease: "easeInOut",
					},
				}}
				className='w-screen lg:h-screen py-20 space-y-10 overflow-hidden'
				id='contact'>
				<h1 className='max-w-7xl pl-4 text-2xl md:text-5xl font-bold text-neutral-800 dark:text-neutral-200 font-sans text-center lg:text-start mx-auto'>
					Contact Us
				</h1>
				<QuestionForm />
			</motion.section>
			<FloatingDock
				mobileClassName='fixed bottom-5 right-5'
				desktopClassName='fixed bottom-5'
				items={[
					{
						title: "Home",
						icon: <IconHome className='w-full text-neutral-300' />,

						onClick: () => {
							scrollToElement("home");
						},
					},
					{
						title: "Products",
						icon: <IconCode className='w-full text-neutral-300' />,

						onClick: () => {
							scrollToElement("products");
						},
					},
					{
						title: "Services",
						icon: <IconDeviceLaptop className='w-full text-neutral-300' />,

						onClick: () => {
							scrollToElement("services");
						},
					},
					{
						title: "About Us",
						icon: <small className='text-[8px] text-white'>Softwarify</small>,

						onClick: () => {
							scrollToElement("aboutus");
						},
					},
					{
						title: "Contact",
						icon: <IconMessage className='w-full text-neutral-300' />,
						onClick: () => {
							scrollToElement("contact");
						},
					},
				]}
			/>
			<motion.footer
				initial={{
					opacity: 0,
					x: -50,
				}}
				whileInView={{
					opacity: 1,
					x: 0,
					transition: {
						duration: 0.5,
						delay: 0.2,
						ease: "easeInOut",
					},
				}}
				className='flex w-full px-10 flex-row items-center justify-between'>
				<div className='flex flex-row gap-x-3 items-center'>
					<span>Follow Us on Social Media: </span>
					<a href='https://linkedin.com/company/softwarify' target='_blank' rel='noreferrer'>
						<IconBrandLinkedin size={30} />
					</a>
					<a href='https://www.instagram.com/softwarify/' target='_blank' rel='noreferrer'>
						<IconBrandInstagram size={32} />
					</a>
				</div>
				<div className='text-lg'>
					<address>Istanbul, Ataşehir, Türkiye</address>
				</div>
			</motion.footer>
		</div>
	);
};

export default HomePage;
